import type {Progress} from './progressSchema';
import {buildProgressScoreMap} from './buildProgressScoreMap';
import {buildRelatedScoresFromMap} from './buildRelatedScoresFromMap';
import {calculateProgressTotals} from './calculateProgressTotals';
import {calculateTotalScoreFromMap} from './calculateTotalScoreFromMap';

export interface ProgressAggregates {
  relatedScores: Record<string, number>;
  totalAnswered: number;
  totalCorrect: number;
  totalScore: number;
}

/**
 * Calculate derived progress aggregates from scores:
 * - relatedScores: per-topic score using the highest difficulty entry
 * - totalAnswered: total questions answered across all scores
 * - totalCorrect: total correctly answered questions
 * - totalScore: average of per-topic scores
 */
export function calculateRelatedScores(progress: Progress): ProgressAggregates {
  const topicScores = buildProgressScoreMap(progress);
  const {totalAnswered, totalCorrect} = calculateProgressTotals(progress);
  const relatedScores = buildRelatedScoresFromMap(topicScores);
  const totalScore = calculateTotalScoreFromMap(topicScores);

  return {
    relatedScores,
    totalAnswered,
    totalCorrect,
    totalScore,
  };
}
